import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { RequireAuth } from "./components/Login-Sys";
import Toaster from './components/Toaster';
import Register from './Register';
import Login from './Login';
import Dashboard from './Dashboard';
import Events from './Events';
import List from './List';
import Gifts from './Gifts';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login/register" element={<Register />} />
        <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>}/>
        <Route path="/events" element={<RequireAuth><Events /></RequireAuth>}/>
        <Route path="/list" element={<RequireAuth><List /></RequireAuth>}/>
        <Route path="/gifts" element={<RequireAuth><Gifts /></RequireAuth>}/>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      <Toaster />
    </Router>
  </React.StrictMode>
);
